<script setup lang="ts">
import { Link, router, usePage } from "@inertiajs/vue3";
import ResponsiveNavLink from "@/Components/ResponsiveNavLink.vue";
import { computed, inject, ref, watch, onMounted, onBeforeUnmount } from "vue";
import { route } from "ziggy-js";
import GoogleOneTap from "@/Pages/Auth/GoogleOneTap.vue";
import SidebarLangSwitch from "@/Components/SidebarLangSwitch.vue";
import MobileSidebarLangSwitch from "@/Components/MobileSidebarLangSwitch.vue";
import RobloxLoginModal from "@/Components/RobloxLoginModal.vue";
import RobloxTransactionsModal from "@/Components/RobloxTransactionsModal.vue";

const logout = () => {
    router.post(route("logout"));
};
const showingNavigationDropdown = ref(false);
const page = usePage<any>();
const isAuthenticated = computed(() => page.props.auth?.user ?? false);
const updateChannel = inject("updateChannel");
const updateMessageChannel = inject("updateMessageChannel");

watch(isAuthenticated, () => {
    updateChannel(page.props.auth?.user);
    updateMessageChannel(page.props.auth?.user);
});
const loginModalIsOpen = ref(false);

const toggleLoginModal = (payload: boolean) => {
    loginModalIsOpen.value = payload;
};

const transactionsModalIsOpen = ref(false);

const toggleTransactionsModal = (payload: boolean) => {
    transactionsModalIsOpen.value = payload;
};

const onLoginClick = () => {
    if (page.props.selected_user?.id) {
        transactionsModalIsOpen.value = true;
        return;
    }
    loginModalIsOpen.value = true;
};

// Allow other components (e.g., Index.vue) to trigger the same logic via a global event
const handleOpenPurchases = () => {
    onLoginClick();
};

onMounted(() => {
    if (typeof window !== "undefined") {
        window.addEventListener("roblox:open-purchases", handleOpenPurchases);
    }
});

onBeforeUnmount(() => {
    if (typeof window !== "undefined") {
        window.removeEventListener(
            "roblox:open-purchases",
            handleOpenPurchases
        );
    }
});
</script>

<template>
    <nav class="bg-[#3d0d8f]">
        <!-- Primary Navigation Menu -->
        <div
            class="max-w-7xl bg-transparent mx-auto px-2 pt-2 sm:px-6 sm:py-0 lg:px-3"
        >
            <div class="flex justify-between items-center min-h-[48px]">
                <Link
                    class="flex justify-self-end col-start-5 col-end-7 sm:px-2 sm:mx-5 lg:mx-0"
                    :href="route('roblox.index')"
                >
                    <img src="/assets/img/roblox/roblox-logo.svg" alt="logo" />
                </Link>
                <!-- Navigation Links -->
                <div
                    class="flex items-center justify-center col-start-auto col-end-13 sm:order-last pr-2 sm:pl-5 justify-self-end gap-2.5"
                >
                    <div class="hidden lg:flex gap-2 text-white items-center">
                        <SidebarLangSwitch />
                    </div>
                    <MobileSidebarLangSwitch />
                    <button
                        @click="onLoginClick"
                        class="rounded-full w-8 h-8 border border-gray-400 flex justify-center items-center bg-transparent hover:bg-blue-400 dark:hover:bg-blue-400 transition-colors duration-200"
                    >
                        <img
                            v-if="page.props.selected_user?.avatarUrl"
                            :src="page.props.selected_user?.avatarUrl"
                            class="rounded-full object-cover"
                            style="width: 24px; height: 20px"
                            alt="avatar"
                        />
                        <ion-icon
                            v-else
                            name="person"
                            class="text-2xl text-slate-100"
                            style="width: 24px; height: 20px"
                        />
                    </button>
                </div>
            </div>
        </div>
        <GoogleOneTap />
        <!--        <YandexOneTap/>-->
    </nav>
    <RobloxLoginModal
        @on-toggle="toggleLoginModal"
        :is-open="loginModalIsOpen"
    />
    <RobloxTransactionsModal
        @on-toggle="toggleTransactionsModal"
        :is-open="transactionsModalIsOpen"
        :selected_user="page.props.selected_user"
    />
</template>
